SupportAPIHelper = require('../helpers/API')
SupportOrderModel = require('../models/order')
SupportOrdersFilterCollection = require('./orders_filter')
SupportUtilsHelper = require('../helpers/utils')

class SupportOrdersCollection

  constructor: () ->
    @hotelImages = {}
    @orders = {}

  saveHotelImage: (order) ->
    if order.DEAL_TYPE is 'GETAWAYS_MARKET_RATE'
      reservationSource = SupportUtilsHelper.getReservationSource(order)
      if reservationSource
        @hotelImages[order.id] = { images: reservationSource.images }

  orderListPath: (options)->
    baseUrl = "#{window.SUPPORTBASEURL}/user/#{currentUser.id}/orders"
    query= ""
    if options.page?
      query = "#{query}page=#{encodeURIComponent(options.page)}&"
    if options.limit?
      query = "#{query}limit=#{encodeURIComponent(options.limit)}&"
    if options.sort_attribute?
      query = "#{query}sort_attribute=#{encodeURIComponent(options.sort_attribute)}&"
    if options.sort_order?
      query = "#{query}sort_order=#{encodeURIComponent(options.sort_order)}&"
    url = "#{baseUrl}?#{query}"

  fetchOrders: (options, successCallback, errorCallback) ->
    options.sort_attribute ||= 'purchased_at'
    options.sort_order ||= 'descending'
    url = @orderListPath(options)

    _successCb = (response) =>
      if response?.orders?.length > 0
        @updateOrderIndexDetails(response)
        successCallback(response)
      else
        successCallback(response || {})

    SupportAPIHelper.get url, null, _successCb, errorCallback, false

  findOrderById: (orderId) ->
    if @hasOrders() && orderId
      orderId = orderId.toString()
      @orders[orderId]
    else
      null

  setOrderSummary: (order) ->
    if order?.id
      orderId = order.id.toString()
      @orders[orderId] = order

  updateOrderIndexDetails: (response) ->
    _.each(response.orders, (responseOrder) =>
      orderFound = @findOrderById(responseOrder.id)
      if orderFound
        return false
      else
        @saveHotelImage(responseOrder)
        @setOrderSummary(responseOrder)
        return true
    )
    response

  hasOrders: () ->
    _.size(@orders) > 0

  getNumberOfOrdersFetched: () ->
    _.size(@orders)

  getHotelImageByOrderId:(orderId) ->
    if @hasOrders()
      @hotelImages[orderId]
    else
      null

  getFilterInstance: (options) ->
    {sort_attribute, sort_order} = options
    if sort_attribute is 'purchased_at'
      if sort_order is "descending"
        @createPurchaseDateDescendingFilter()
      else
        @createPurchaseDateAscendingFilter()
    else
      if sort_order is "descending"
        @createMerchantNameDescendingFilter()
      else
        @createMerchantNameAscendingFilter()

  createPurchaseDateAscendingFilter: () ->
    return @purchaseDateAscendingFilter if @purchaseDateAscendingFilter
    options =
      sort_attribute : "purchased_at"
      sort_order: "ascending"
    @purchaseDateAscendingFilter = @createFilter(options)

  createPurchaseDateDescendingFilter: () ->
    return @purchaseDateDescendingFilter if @purchaseDateDescendingFilter
    options =
      sort_attribute : "purchased_at"
      sort_order: "descending"
    @purchaseDateDescendingFilter = @createFilter(options)

  createMerchantNameAscendingFilter: () ->
    return @merchantNameAscendingFilter if @merchantNameAscendingFilter
    options =
      sort_attribute : "merchant_name"
      sort_order: "ascending"
    @merchantNameAscendingFilter = @createFilter(options)

  createMerchantNameDescendingFilter: () ->
    return @merchantNameDescendingFilter if @merchantNameDescendingFilter
    options =
      sort_attribute : "merchant_name"
      sort_order: "descending"
    @merchantNameDescendingFilter = @createFilter(options)

  createFilter: (options) ->
    new SupportOrdersFilterCollection(options)

module.exports = SupportOrdersCollection
